module.exports = __webpack_public_path__ + "assets/img/tab2_01.7d2a9d80.jpg";